module.exports = __webpack_public_path__ + "static/media/car-tilt.d6ad24b0.svg";